const footerSubMenuTarget = '.wm-footer__menu .menu-item-has-children';
jQuery(document).on('ready', function () {
    jQuery(footerSubMenuTarget).click(function () {
        jQuery(this).children('.sub-menu').slideToggle();
    });
});
